import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';

import {FunktionsbereicheChecklistenPage} from './funktionsbereiche-checklisten.page';
import {reducers} from './funktionsbereich-checklisten.reducer';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {FunktionsbereicheChecklistenPageUiEffects} from './funktionsbereich-checklisten.effects.ui';
import {
    VeranstaltungenFunktionsbereichFreigebenEffects,
    VeranstaltungenVeranstaltungFreigebenEffects,
    VeranstaltungenVeranstaltungFunktionsbereicheChecklistenEffects,
    VeranstaltungenVeranstaltungPhaseBeendenEffects
} from '../../../../client-ngrx/veranstaltungen';
import {SopiComponentsModule} from '../../../shared/sopi-components/sopi-components.module';
import {PipesSharedModule} from '../../../shared/pipes/pipes-shared.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        StoreModule.forFeature('FunktionsbereicheChecklistenPage', reducers),
        EffectsModule.forFeature([
            FunktionsbereicheChecklistenPageUiEffects,
            VeranstaltungenVeranstaltungFunktionsbereicheChecklistenEffects,
            VeranstaltungenVeranstaltungFreigebenEffects,
            VeranstaltungenFunktionsbereichFreigebenEffects,
            VeranstaltungenVeranstaltungPhaseBeendenEffects
        ]),
        SopiComponentsModule.forRoot(),
        PipesSharedModule,
    ],
    exports: [
        FunktionsbereicheChecklistenPage
    ],
    declarations: [FunktionsbereicheChecklistenPage]
})
export class FunktionsbereicheChecklistenPageModule {
}
